import React from 'react';
import { siteConfig } from '../../config/siteConfig';
import './Hero.css';

const Hero = () => {
  const { hero } = siteConfig;

  return (
    <section className="hero">
      <div className="hero-container">
        
        {/* First Line Scrolling Text */}
        <div className="hero-text-line">
          <div className="scrolling-text hero-scroll" data-speed={hero.firstLine.speed}>
            <span className="hero-text">
              {Array(15).fill(null).map((_, index) => (
                <span key={index} className={index === 1 ? 'solid' : 'outline'}>
                  {hero.firstLine.text}&nbsp;
                </span>
              ))}
            </span>
          </div>
        </div>

        {/* Second Line Scrolling Text */}
        <div className="hero-text-line">
          <div className="scrolling-text hero-scroll" data-speed={hero.secondLine.speed}>
            <span className="hero-text">
              {Array(15).fill(null).map((_, index) => (
                <span key={index} className={index === 1 ? 'solid' : 'outline'}>
                  {hero.secondLine.text}&nbsp;
                </span>
              ))}
            </span>
          </div>
        </div>

        {/* Tagline */}
        {hero.tagline.show && (
          <div className="hero-tagline">
            <p>{hero.tagline.text}</p>
          </div>
        )}

      </div>
    </section>
  );
};

export default Hero; 